import { render, staticRenderFns } from "./StoreReservationList.vue?vue&type=template&id=5d8f1532&scoped=true&"
import script from "./StoreReservationList.vue?vue&type=script&lang=js&"
export * from "./StoreReservationList.vue?vue&type=script&lang=js&"
import style1 from "./StoreReservationList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f1532",
  null
  
)

export default component.exports